import BASE_API from '@/api/dataBase';
import dictAPI from '@/api/systemManage/dict.js';

export default {
  data() {
    return {
      companyList: [],
      departmentList: [],
      newCompanyList: [],
    };
  },
  methods: {
    // async getCompanyApi() {
    //   const { data } = await this.$axios.post(COMPANY_API.GET_COMPANY_LIST_API, {
    //     adminFlag: this.userInfo.adminFlag,
    //     tenantCode: this.userInfo.tenantCode,
    //   });
    //   if (data.code == 0) {
    //     this.companyList = data.data.map((item) => {
    //       return {
    //         companyName: item.createCompanyName,
    //         companyCode: item.createCompanyCode,
    //       };
    //     });
    //   } else {
    //     console.error('获取公司失败');
    //   }
    // },
    // // 根据公司code获取部门
    // async getDepartmentByCompanyCodeApi(companyCode) {
    //   const { data } = await this.$axios.post(COMPANY_API.GET_DEPARTMENT_LIST_API, {
    //     belongCompanyCode: companyCode,
    //     tenantCode: this.userInfo.tenantCode,
    //   });
    //   if (data.code == 0) {
    //     this.departmentList = data.data.map((item) => {
    //       return {
    //         departmentCode: item.createDepartmentCode,
    //         departmentName: item.createDepartmentName,
    //       };
    //     });
    //   } else {
    //     console.error('获取公司失败');
    //   }
    // },

    //获取字典公司数据
    async getListData() {
      await this.$axios
        .post(dictAPI.DICT_DATA_DICT_API, {
          // 生产环境dictCode 202407031048117299035
          dictCode: '202406211727166954331',
          dataStatus: 0,
          pageNum: 1,
          pageSize: 100,
        })
        .then((res) => {
          if (0 == res.data.code) {
            this.newCompanyList = res.data.data.list;
            console.log('this.newCompanyList', this.newCompanyList);
            if (
              ['edit', 'detail'].includes(this.$route.query?.status) ||
              (['create'].includes(this.$route.query?.status) && this.$route.query?.id?.length > 0)
            ) {
              console.log('编辑');
            }
          } else {
            this.$alert(res.data.msg);
          }
        });
    },
    // 获取公司
    /*async _getCompanyApi() {
      console.log('开始获取公司', this.userInfo);
      const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
        id: this.userInfo.userCode,
        userCode: this.userInfo.userCode,
        personName: this.userInfo.userName,
      });
      if (data.code == 0) {
        console.log(data.data, '???=====》》');
        this.companyList = data.data?.personCompanyInfo;
        console.log(this.companyList, 'companyList');
        console.log(this.userInfo.companyCode, 'this.userInfo.companyCode');
        if (
          ['edit', 'detail'].includes(this.$route.query?.status) ||
          (['create'].includes(this.$route.query?.status) && this.$route.query?.id?.length > 0)
        ) {
          console.log('编辑');
        } else {
          if (!this.userInfo.companyCode) {
            const companyCode = data.data.personCompanyInfo
              ? data.data.personCompanyInfo[0].companyCode
              : null;
            const companyName = data.data.personCompanyInfo
              ? data.data.personCompanyInfo[0].companyName
              : null;
            this.baseFormData = {
              ...this.baseFormData,
              settlementCompanyNo: companyCode,
              settlementCompanyName: companyName,
            };
          } else {
            this.baseFormData = {
              ...this.baseFormData,
              settlementCompanyNo: this.userInfo.companyCode,
              settlementCompanyName: this.userInfo.companyName,
            };
          }
        }

        this._getDepartmentByCompanyCodeApi(this.baseFormData.settlementCompanyNo, true);
      } else {
        console.error('获取公司失败');
      }
    },*/
    // 根据公司获取部门
    async _getDepartmentByCompanyCodeApi(companyCode, isFirst = false) {
      const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
        id: this.userInfo.userCode,
        userCode: this.userInfo.userCode,
        personName: this.userInfo.userName,
        personCompanyCode: companyCode,
      });
      if (data.code == 0) {
        console.log(data.data, '部门信息');
        this.departmentList = data.data?.personDepartmentInfo;
        if (
          ['edit', 'detail'].includes(this.$route.query?.status) ||
          (['create'].includes(this.$route.query?.status) && this.$route.query?.id?.length > 0)
        ) {
          console.log('编辑');
        } else {
          if (isFirst) {
            this.baseFormData = {
              ...this.baseFormData,
              settlementDepartmentNo: this.userInfo?.departmentCode,
              settlementDepartmentName: this.userInfo?.departmentName,
            };
          }
        }
      } else {
        console.error('获取部门失败');
      }
    },
    //修改汇率后的更新
    exchangeRateHandler(exchangeRate) {
      this.settleAccountsDetailMap.forEach((value, key) => {
        if (value.length > 0) {
          value.forEach((item) => {
            item['exchangeRate'] = exchangeRate;
            item['domesticAmount'] = (item['originalAmount'] * +exchangeRate).toFixed(2);
          });
        }
        this.settleAccountsDetailMap.set(key, value);
      });
      if (this.settleAccountsRowList.length > 0) {
        this.settleAccountsRowList.forEach((item) => {
          item['exchangeRate'] = exchangeRate;
          item['domesticAmount'] = (item['originalAmount'] * +exchangeRate).toFixed(2);
        });
        setTimeout(() => {
          this._computeRowTableTotalAmount(this.settleAccountsRowList);
        }, 50);
      }
    },
    //修改货币类型的更新
    currencyCodeHandler() {
      const { currencyCode, currencyName } = this.baseFormData;
      this.settleAccountsDetailMap.forEach((value, key) => {
        if (value.length > 0) {
          value.forEach((item) => {
            item['currencyCode'] = currencyCode;
            item['currencyName'] = currencyName;
          });
        }
        this.settleAccountsDetailMap.set(key, value);
      });
      if (this.settleAccountsRowList.length > 0) {
        this.settleAccountsRowList.forEach((item) => {
          item['currencyCode'] = currencyCode;
          item['currencyName'] = currencyName;
        });
      }
    },
  },
  watch: {
    'baseFormData.exchangeRate': {
      deep: true,
      handler: function (newV, oldV) {
        console.log(newV, 'watch中：exchangeRate', oldV);
        if (newV !== oldV) {
          this.exchangeRateHandler(newV);
        }
      },
    },
    'baseFormData.currencyCode': {
      deep: true,
      handler: function (newV, oldV) {
        console.log('watch中：currencyCode', newV);
        if (newV !== oldV) {
          this.currencyCodeHandler();
        }
      },
    },
  },
  mounted() {
    // this.getCompanyApi();
    this.$nextTick(() => {
      // this._getCompanyApi();
      this.getListData();
    });
    if (['create'].includes(this.$route.query?.status)) {
      this.baseFormData = {
        ...this.baseFormData,
        salesmanNo: this.userInfo.personNo,
        salesmanName: this.userInfo.personName,
      };
    }
  },
};
